import React from 'react'

import { easasAlert } from 'components/fragments/easas-global-fragment/EasasGlobalAlerts'
import { MdmObject, useGetObjectQuery, useUpdateObjectMutation } from 'gql/generated/types'
import { ProgressSpinner } from 'primereact/progressspinner'
import { useNavigate, useParams } from 'react-router-dom'
import ObjectForm from '../components/ObjectForm'
import ErrorPage from './ErrorPage'

const EditObjectForm = () => {
  const params = useParams()
  const navigate = useNavigate()
  const { data, error, loading } = useGetObjectQuery({ variables: { id: params.objectId! } });
  const [mutateFunction] = useUpdateObjectMutation({
    onCompleted: () => {
      easasAlert({
        severity: "success",
        summary: "Success",
        detail: "Object updated successfully",
        life: 3000,
      });
      navigate("/");
    },
    onError: err => {
      easasAlert({ severity: "error", summary: "Error", detail: err.message, life: 3000 });
    },
    refetchQueries: ["GetObjectsByProject", "GetObject"],
  });
  
  if (error) {
    return <ErrorPage msg={`Object not found by id: ${params.objectId}`} />;
  }

  if (loading) return <ProgressSpinner className='mt-3 w-full' />

  const handleUpdate = (object: Partial<MdmObject>) => {
    const { devices, project, ...restObject } = object
    mutateFunction({ variables: { object: restObject } })

  }

  return <ObjectForm object={data?.mdmObjectById as MdmObject} onSubmit={handleUpdate} />
}

export default EditObjectForm